"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AccountSource = _interopRequireDefault(require("./AccountSource"));
var _AtomLink = _interopRequireDefault(require("./AtomLink"));
var _ChannelPreferences = _interopRequireDefault(require("./ChannelPreferences"));
var _CommunicationPreferences = _interopRequireDefault(require("./CommunicationPreferences"));
var _DeliveryAddress = _interopRequireDefault(require("./DeliveryAddress"));
var _Device = _interopRequireDefault(require("./Device"));
var _GlobalPreferences = _interopRequireDefault(require("./GlobalPreferences"));
var _HomeAddress = _interopRequireDefault(require("./HomeAddress"));
var _IdentificationDetails = _interopRequireDefault(require("./IdentificationDetails"));
var _PaymentPreferences = _interopRequireDefault(require("./PaymentPreferences"));
var _PersonalDetails = _interopRequireDefault(require("./PersonalDetails"));
var _Role = _interopRequireDefault(require("./Role"));
var _SimCard = _interopRequireDefault(require("./SimCard"));
var _TwoFactorAuthPreferences = _interopRequireDefault(require("./TwoFactorAuthPreferences"));
var _User = _interopRequireDefault(require("./User"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Customer model module.
 * @module model/Customer
 * @version 3.0
 */
var Customer = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Customer</code>.
   * @alias module:model/Customer
   */
  function Customer() {
    _classCallCheck(this, Customer);
    Customer.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Customer, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>Customer</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Customer} obj Optional instance to populate.
     * @return {module:model/Customer} The populated <code>Customer</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Customer();
        if (data.hasOwnProperty('customerId')) {
          obj['customerId'] = _ApiClient["default"].convertToType(data['customerId'], 'Number');
        }
        if (data.hasOwnProperty('category')) {
          obj['category'] = _ApiClient["default"].convertToType(data['category'], 'String');
        }
        if (data.hasOwnProperty('customerLegacyId')) {
          obj['customerLegacyId'] = _ApiClient["default"].convertToType(data['customerLegacyId'], 'String');
        }
        if (data.hasOwnProperty('levelId')) {
          obj['levelId'] = _ApiClient["default"].convertToType(data['levelId'], 'Number');
        }
        if (data.hasOwnProperty('identificationDetails')) {
          obj['identificationDetails'] = _IdentificationDetails["default"].constructFromObject(data['identificationDetails']);
        }
        if (data.hasOwnProperty('personalDetails')) {
          obj['personalDetails'] = _PersonalDetails["default"].constructFromObject(data['personalDetails']);
        }
        if (data.hasOwnProperty('globalPreferences')) {
          obj['globalPreferences'] = _GlobalPreferences["default"].constructFromObject(data['globalPreferences']);
        }
        if (data.hasOwnProperty('paymentPreferences')) {
          obj['paymentPreferences'] = _PaymentPreferences["default"].constructFromObject(data['paymentPreferences']);
        }
        if (data.hasOwnProperty('twoFactorAuthPreferences')) {
          obj['twoFactorAuthPreferences'] = _TwoFactorAuthPreferences["default"].constructFromObject(data['twoFactorAuthPreferences']);
        }
        if (data.hasOwnProperty('communicationPreferences')) {
          obj['communicationPreferences'] = _CommunicationPreferences["default"].constructFromObject(data['communicationPreferences']);
        }
        if (data.hasOwnProperty('homeAddress')) {
          obj['homeAddress'] = _HomeAddress["default"].constructFromObject(data['homeAddress']);
        }
        if (data.hasOwnProperty('deliveryAddress')) {
          obj['deliveryAddress'] = _DeliveryAddress["default"].constructFromObject(data['deliveryAddress']);
        }
        if (data.hasOwnProperty('user')) {
          obj['user'] = _User["default"].constructFromObject(data['user']);
        }
        if (data.hasOwnProperty('roleName')) {
          obj['roleName'] = _ApiClient["default"].convertToType(data['roleName'], 'String');
        }
        if (data.hasOwnProperty('role')) {
          obj['role'] = _Role["default"].constructFromObject(data['role']);
        }
        if (data.hasOwnProperty('channelPreferences')) {
          obj['channelPreferences'] = _ApiClient["default"].convertToType(data['channelPreferences'], [_ChannelPreferences["default"]]);
        }
        if (data.hasOwnProperty('accountSources')) {
          obj['accountSources'] = _ApiClient["default"].convertToType(data['accountSources'], [_AccountSource["default"]]);
        }
        if (data.hasOwnProperty('devices')) {
          obj['devices'] = _ApiClient["default"].convertToType(data['devices'], [_Device["default"]]);
        }
        if (data.hasOwnProperty('simcards')) {
          obj['simcards'] = _ApiClient["default"].convertToType(data['simcards'], [_SimCard["default"]]);
        }
        if (data.hasOwnProperty('_links')) {
          obj['_links'] = _ApiClient["default"].convertToType(data['_links'], [_AtomLink["default"]]);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Customer</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Customer</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['category'] && !(typeof data['category'] === 'string' || data['category'] instanceof String)) {
        throw new Error("Expected the field `category` to be a primitive type in the JSON string but got " + data['category']);
      }
      // ensure the json data is a string
      if (data['customerLegacyId'] && !(typeof data['customerLegacyId'] === 'string' || data['customerLegacyId'] instanceof String)) {
        throw new Error("Expected the field `customerLegacyId` to be a primitive type in the JSON string but got " + data['customerLegacyId']);
      }
      // validate the optional field `identificationDetails`
      if (data['identificationDetails']) {
        // data not null
        _IdentificationDetails["default"].validateJSON(data['identificationDetails']);
      }
      // validate the optional field `personalDetails`
      if (data['personalDetails']) {
        // data not null
        _PersonalDetails["default"].validateJSON(data['personalDetails']);
      }
      // validate the optional field `globalPreferences`
      if (data['globalPreferences']) {
        // data not null
        _GlobalPreferences["default"].validateJSON(data['globalPreferences']);
      }
      // validate the optional field `paymentPreferences`
      if (data['paymentPreferences']) {
        // data not null
        _PaymentPreferences["default"].validateJSON(data['paymentPreferences']);
      }
      // validate the optional field `twoFactorAuthPreferences`
      if (data['twoFactorAuthPreferences']) {
        // data not null
        _TwoFactorAuthPreferences["default"].validateJSON(data['twoFactorAuthPreferences']);
      }
      // validate the optional field `communicationPreferences`
      if (data['communicationPreferences']) {
        // data not null
        _CommunicationPreferences["default"].validateJSON(data['communicationPreferences']);
      }
      // validate the optional field `homeAddress`
      if (data['homeAddress']) {
        // data not null
        _HomeAddress["default"].validateJSON(data['homeAddress']);
      }
      // validate the optional field `deliveryAddress`
      if (data['deliveryAddress']) {
        // data not null
        _DeliveryAddress["default"].validateJSON(data['deliveryAddress']);
      }
      // validate the optional field `user`
      if (data['user']) {
        // data not null
        _User["default"].validateJSON(data['user']);
      }
      // ensure the json data is a string
      if (data['roleName'] && !(typeof data['roleName'] === 'string' || data['roleName'] instanceof String)) {
        throw new Error("Expected the field `roleName` to be a primitive type in the JSON string but got " + data['roleName']);
      }
      // validate the optional field `role`
      if (data['role']) {
        // data not null
        _Role["default"].validateJSON(data['role']);
      }
      if (data['channelPreferences']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['channelPreferences'])) {
          throw new Error("Expected the field `channelPreferences` to be an array in the JSON data but got " + data['channelPreferences']);
        }
        // validate the optional field `channelPreferences` (array)
        var _iterator = _createForOfIteratorHelper(data['channelPreferences']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _ChannelPreferences["default"].validateJSON(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ;
      }
      if (data['accountSources']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['accountSources'])) {
          throw new Error("Expected the field `accountSources` to be an array in the JSON data but got " + data['accountSources']);
        }
        // validate the optional field `accountSources` (array)
        var _iterator2 = _createForOfIteratorHelper(data['accountSources']),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _item = _step2.value;
            _AccountSource["default"].validateJSON(_item);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        ;
      }
      if (data['devices']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['devices'])) {
          throw new Error("Expected the field `devices` to be an array in the JSON data but got " + data['devices']);
        }
        // validate the optional field `devices` (array)
        var _iterator3 = _createForOfIteratorHelper(data['devices']),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _item2 = _step3.value;
            _Device["default"].validateJSON(_item2);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        ;
      }
      if (data['simcards']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['simcards'])) {
          throw new Error("Expected the field `simcards` to be an array in the JSON data but got " + data['simcards']);
        }
        // validate the optional field `simcards` (array)
        var _iterator4 = _createForOfIteratorHelper(data['simcards']),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _item3 = _step4.value;
            _SimCard["default"].validateJSON(_item3);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        ;
      }
      if (data['_links']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['_links'])) {
          throw new Error("Expected the field `_links` to be an array in the JSON data but got " + data['_links']);
        }
        // validate the optional field `_links` (array)
        var _iterator5 = _createForOfIteratorHelper(data['_links']),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _item4 = _step5.value;
            _AtomLink["default"].validateJSON(_item4);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        ;
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} customerId
 */
Customer.prototype['customerId'] = undefined;

/**
 * @member {String} category
 */
Customer.prototype['category'] = undefined;

/**
 * @member {String} customerLegacyId
 */
Customer.prototype['customerLegacyId'] = undefined;

/**
 * @member {Number} levelId
 */
Customer.prototype['levelId'] = undefined;

/**
 * @member {module:model/IdentificationDetails} identificationDetails
 */
Customer.prototype['identificationDetails'] = undefined;

/**
 * @member {module:model/PersonalDetails} personalDetails
 */
Customer.prototype['personalDetails'] = undefined;

/**
 * @member {module:model/GlobalPreferences} globalPreferences
 */
Customer.prototype['globalPreferences'] = undefined;

/**
 * @member {module:model/PaymentPreferences} paymentPreferences
 */
Customer.prototype['paymentPreferences'] = undefined;

/**
 * @member {module:model/TwoFactorAuthPreferences} twoFactorAuthPreferences
 */
Customer.prototype['twoFactorAuthPreferences'] = undefined;

/**
 * @member {module:model/CommunicationPreferences} communicationPreferences
 */
Customer.prototype['communicationPreferences'] = undefined;

/**
 * @member {module:model/HomeAddress} homeAddress
 */
Customer.prototype['homeAddress'] = undefined;

/**
 * @member {module:model/DeliveryAddress} deliveryAddress
 */
Customer.prototype['deliveryAddress'] = undefined;

/**
 * @member {module:model/User} user
 */
Customer.prototype['user'] = undefined;

/**
 * @member {String} roleName
 */
Customer.prototype['roleName'] = undefined;

/**
 * @member {module:model/Role} role
 */
Customer.prototype['role'] = undefined;

/**
 * @member {Array.<module:model/ChannelPreferences>} channelPreferences
 */
Customer.prototype['channelPreferences'] = undefined;

/**
 * @member {Array.<module:model/AccountSource>} accountSources
 */
Customer.prototype['accountSources'] = undefined;

/**
 * @member {Array.<module:model/Device>} devices
 */
Customer.prototype['devices'] = undefined;

/**
 * @member {Array.<module:model/SimCard>} simcards
 */
Customer.prototype['simcards'] = undefined;

/**
 * @member {Array.<module:model/AtomLink>} _links
 */
Customer.prototype['_links'] = undefined;
var _default = exports["default"] = Customer;